<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box" v-if="emp_sal_master_details!=''">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Edit Employee Salary Master</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row dense justify="center">
                <v-col cols="12" sm="2" md="2">
                    <p><b>Pay Commision*</b></p>
                    <v-text-field v-model="emp_sal_master_details[0].paycommission" rounded outlined dense readonly> </v-text-field>
                </v-col>
                <v-col v-if="org_id=='sanjivani'"  cols="12" sm="2" md="2">
                    <p><b>Increment Year*</b></p>
                    <v-text-field v-model="emp_sal_master_details[0].incrementyear" rounded outlined dense readonly> </v-text-field>
                </v-col>
                <v-col v-if="org_id=='sanjivani'"  cols="12" sm="2" md="2">
                    <p><b>Month*</b></p>
                    <v-text-field v-model="emp_sal_master_details[0].salarymonth" rounded outlined dense readonly> </v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <p><b>From Date*</b></p>
                    <v-menu v-model="menu11" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                persistent-hint
                                hint="Select From Date"
                                placeholder="Select From Date YYYY/MM/DD format"
                                color="#0F2027"
                                v-model="from_date_edit"
                                outlined
                                rounded
                                dense
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="from_date_edit" @input="menu11 = false"></v-date-picker>
                    </v-menu>
                    <!-- <input id="datePickerId" type="date" v-model="date_1" /> -->
                </v-col>
                <v-col cols="12" sm="3">
                    <p><b>To Date*</b></p>
                    <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                color="#0F2027"
                                persistent-hint
                                hint="Select From Date YYYY/MM/DD format"
                                placeholder="Select From Date"
                                v-model="end_date_edit"
                                outlined
                                rounded
                                dense
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker :min="from_date_edit" v-model="end_date_edit" @input="menu2 = false"></v-date-picker>
                    </v-menu>
                    <!-- <input id="datePickerId" type="date" v-model="date_2" /> -->
                </v-col>
            </v-row>
            <span v-if="uan_no">
                        <input id="is_uan" type="hidden" name="is_uan" value="true" />
                    </span>
                    <span v-else>
                        <input id="is_uan" type="hidden" name="is_uan" value="false" />
                    </span>
            <v-row dense justify="center" v-for="s in emp_sal_master_details[0].component_rule" :key="s.id">
                <v-col cols="12" md="3" sm="3">{{s.s_d_name}}</v-col>
                <v-col cols="12" md="3" sm="3">
                    <v-text-field type="number" v-model="s.s_value" rounded outlined dense @change="recalculate();calculateRuleWise();"> </v-text-field>
                </v-col>
                <v-col cols="12" md="3" sm="3">
                    <span v-if="s.is_rule_applicable == true && s.rule_value">
                    <v-tooltip top color="black">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" color="black">mdi-information</v-icon>
                        </template>
                        <span>
                           {{s.rule_value}}
                        </span>
                    </v-tooltip>
                    <v-tooltip top color="black">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" color="red" @click="removeRule(s)">mdi-filter-remove</v-icon>
                        </template>
                        <span>
                           Remove Applied Rule
                        </span>
                    </v-tooltip>
                     
                    </span>
                    <span v-if="s.is_rule_applicable == true">
                        <v-avatar style="" size="25" class="edit-avatar ml-10 mt-2" @click="addRule(s.s_id)">
                            <v-icon class="edit-v-icon mr-2">edit</v-icon>
                        </v-avatar>
                    </span>
                </v-col>
                <input class="compvalue" id="compvalue" type="hidden" name="compvalue" :value="s.s_value" />
                <input class="compname" id="compname" type="hidden" name="compname" :value="s.s_name" />
                <input class="comptype" id="comptype" type="hidden" name="comptype" :value="s.salarycomponenttype" />
                <input class="iscalculationnotapplyall" id="iscalculationnotapplyall" type="hidden" name="iscalculationnotapplyall" :value="s.is_not_for_calculation" />
                <input class="comprule" type="hidden" id="comprule" name="comprule" :value="s.rule_value" />
                <input class="comprule_id" type="hidden" id="comprule_id" name="comprule_id" :value="s.rule_id" />
            </v-row>
            <v-row dense justify="center">
                <v-col cols="12" md="3" sm="3">
                    <p><b>Gross Earning</b></p>
                    <v-text-field class="ml-2 mr-2" filled readonly type="number" v-model="grossearn" rounded outlined dense> </v-text-field>
                </v-col>
                <v-col cols="12" md="3" sm="3">
                    <p><b>Gross Deduction</b></p>
                    <v-text-field class="ml-2 mr-2" filled readonly type="number" v-model="grossdeduct" rounded outlined dense> </v-text-field>
                </v-col>
                <v-col cols="12" md="3" sm="3">
                    <p><b>Net Salary</b></p>
                    <v-text-field class="ml-2 mr-2" filled readonly type="number" v-model="netsal" rounded outlined dense> </v-text-field>
                </v-col>
            </v-row>
            <v-row dense justify="center">
                <v-btn v-if="edit_flag == 'yes'" @click="updateEmpSalaryMaster()" :loading="create_loader" class="button">Update</v-btn>
            </v-row>
        </v-card>
        <v-dialog v-model="dialog_edit_rule" persistent max-width="1200px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Add Rule
                        </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <center>
                    <v-col cols="12" sm="6" md="6">
                        <v-autocomplete dense rounded outlined v-model="comp_rule" :items="component_rule" color="#0F2027" item-text="name" return-object label="Rule" single-line></v-autocomplete>
                    </v-col>
                </center>
                <v-row justify="center">
                    <v-btn rounded class="button" @click="addrule_edit(comp_rule);">Save</v-btn>
                    <v-btn rounded class="button" @click="dialog_edit_rule = false">Close</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import axios from "axios";
    export default {
        props: ["emp_sal_id", "dialog_edit","edit_flag"],

        data: () => ({
            snackbar_msg: "",
            color: "",
            snackbar: false,
            emp_sal_master_details: [],
            from_date_edit: null,
            end_date_edit: null,
            menu: false,
            menu2: false,
            menu1: false,
            menu11: false,
            dialog_edit_rule: false,
            component_rule: [],
            comp_rule: null,
            grossearn: 0,
            grossdeduct: 0,
            netsal: 0,
            gender: null,
            pfno: null,
            uan_no: null,
            is_handicap: null,
            aadhar_no: null,
            create_loader:false,
            org_id:null,
        }),

        mounted() {
            this.org_id = localStorage.getItem("EPS-tenant");
            this.onload();
        },
        methods: {
            recalculate() {
                // var iscalculationnotapply = document.getElementsByClassName("iscalculationnotapplyall");
                // var compvalue = document.getElementsByClassName("compvalue");
                // var comptype = document.getElementsByClassName("comptype");

                var totalearn = 0;
                var totaldeduct = 0;
                // for (var i = 0; i < compvalue.length; i++) {
                //     if (iscalculationnotapply[i].value != "true") {
                //         if (Number.isNaN(parseFloat(compvalue[i].value)) || compvalue[i].value == "") {
                //             if (comptype[i].value == "Earning") totalearn += parseInt("0.0");
                //             else totaldeduct += parseInt("0.0");
                //         } else {
                //             if (comptype[i].value == "Earning") totalearn += parseFloat(compvalue[i].value);
                //             else totaldeduct += parseFloat(compvalue[i].value);
                //         }
                //     }
                // }
                 for (var i = 0; i < this.emp_sal_master_details[0].component_rule.length; i++) {
                   // alert(this.emp_sal_master_details[0].component_rule[i].salarycomponenttype)
                    if (this.emp_sal_master_details[0].component_rule[i].is_not_for_calculation != "true") {
                        if (Number.isNaN(parseFloat(this.emp_sal_master_details[0].component_rule[i].s_value)) || this.emp_sal_master_details[0].component_rule[i].s_value == "") {
                            if (comptype[i].value == "Earning") {
                                totalearn += parseInt("0.0");
                            } else {
                                totaldeduct += parseInt("0.0");
                            }
                        } else {
                            if (this.emp_sal_master_details[0].component_rule[i].salarycomponenttype == "Earning") {
                                totalearn += parseFloat(this.emp_sal_master_details[0].component_rule[i].s_value);
                            } else {
                                totaldeduct += parseFloat(this.emp_sal_master_details[0].component_rule[i].s_value);
                            }
                        }
                    }
                 }
                this.grossearn = totalearn;
                this.grossdeduct = totaldeduct;
                this.netsal = totalearn - totaldeduct;
            },
            calculateRuleWise() {
                var compvalue = document.getElementsByClassName("compvalue");
                var compname = document.getElementsByClassName("compname");
                var comprule = document.getElementsByClassName("comprule");
                var comprule_id = document.getElementsByClassName("comprule_id");
                var comptype = document.getElementsByClassName("comptype");
                var iscalculationnotapply = document.getElementsByClassName("iscalculationnotapplyall");

                var array = [];
                var arrayComponent = [];
               var basicpay = 0;
                var gradepay = 0;
                var da = 0;
                var dp = 0;
                var hra = 0
                var ta = 0
                var cla = 0
                var otherallowance = 0
                var sppa = 0
                var spal = 0
                var arrears = 0
                var grosssalary = 0;
                var esic = 0
                var stamp = 0
                for (var i = 0; i < compname.length; i++) {
                    let obj = {
                        component: compname[i].value,
                        value: parseFloat(compvalue[i].value),
                        rule: comprule[i].value,
                        rule_id: comprule_id[i].value
                    };
                   // console.log(compname[i].value)
                    // if(comprule[i].value !=""){
                    //     alert(comprule[i].value)
                    // }
                    if (compname[i].value == "BasicPay") {
                        basicpay = parseFloat(compvalue[i].value);
                        // alert("bp"+basicpay)
                    }

                    if (compname[i].value == "GradePay") {
                        gradepay = parseFloat(compvalue[i].value);
                        // alert("gp"+gradepay)
                    }
                    if (compname[i].value == "D.A.") {
                        da = parseFloat(compvalue[i].value);
                        // alert(da)
                    }
                    if (compname[i].value == "D.P.") {
                        dp = parseFloat(compvalue[i].value);
                        //  alert(dp)
                    }
                    if(compname[i].value == 'H.R.A.'){
                          hra = parseFloat(compvalue[i].value);
                    }
                      if(compname[i].value == 'T.A.'){
                          ta = parseFloat(compvalue[i].value);
                      }
                      if(compname[i].value == 'C.L.A.'){
                          cla = parseFloat(compvalue[i].value);
                      }
                      if(compname[i].value == 'Other Allowance'){
                         otherallowance = parseFloat(compvalue[i].value);
                      }
                      if(compname[i].value == 'SPPAY'){
                         sppa = parseFloat(compvalue[i].value);
                      }
                      if(compname[i].value == 'SPAL'){
                         spal = parseFloat(compvalue[i].value);
                      }
                      if(compname[i].value == 'Increment Arrears'){
                        arrears = parseFloat(compvalue[i].value);
                      }
                      if(compname[i].value == 'ESIC'){
                         esic = parseFloat(compvalue[i].value);
                      }
                       if(compname[i].value == 'STAMP'){
                         stamp = parseFloat(compvalue[i].value);
                      }
                        
                    if (comptype[i].value == "Earning") {
                        if (iscalculationnotapply[i].value != "true") grosssalary = grosssalary + parseFloat(compvalue[i].value);
                    }
                    array.push(obj);
                }
              //  console.log("array::::",array)
                for (var i = 0; i < array.length; i++) {
                    if (array[i].rule) {
                       // alert("in if rule")
                        var val = 0;
                        if (array[i].rule == "WELFARE_NOT_APPLICABLE") 
                        {
                            val = 0;
                        }
                        else 
                        {
                            val = this.getRuleValue(basicpay, gradepay, da, dp,  hra, ta, cla, otherallowance,arrears,grosssalary, array[i].rule,sppa,spal);
                            this.emp_sal_master_details[0].component_rule[i].s_value = val
                            this.emp_sal_master_details[0].component_rule[i].rule_value = array[i].rule
                            this.emp_sal_master_details[0].component_rule[i].rule_id = array[i].rule_id
                        }
                    }
                }
                this.recalculate();
            },
             getRuleValue(basicpay, gradepay, da, dp, hra, ta, cla, otherallowance,arrears,grosssalary, rule,sppa,spal) {
               // alert("basicpay"+basicpay)
                rule = rule.split(":");
              //  alert(rule[1])
              //  alert(rule.length)
                var amount = 0;
                if (
                    rule[0] == "PER_OF_BASIC" ||
                    rule[0] == "PER_OF_BASIC_PLUS_GP" ||
                    rule[0] == "PER_OF_BASIC_PLUS_DP" ||
                    rule[0] == "PER_OF_BASIC_PLUS_GP_PLUS_DA" ||
                    rule[0] == "PER_OF_BASIC_PLUS_DP_PLUS_DA" ||
                    rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_DA" ||
                    rule[0] == "PF_RULE_PER_OF_BASIC" ||
                    rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_GP_PLUS_DA" ||
                    rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_DP_PLUS_DA" ||
                    rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_GP_PLUS_DA_PLUS_CLA_PLUS_TA_PLUS_OTHER ALLOWANCE" ||
                    rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_GP_PLUS_DA_PLUS_CLA_PLUS_TA_PLUS_OTHER ALLOWANCE_PLUS_ARREARS" ||
                    rule[0] == "PF_RULE_WITH_UAN_MUST_PER_OF_BASIC_PLUS_GP_PLUS_DA_PLUS_CLA_PLUS_TA_PLUS_OTHER_ALLOWANCE" ||
                    rule[0] == "PF_RULE_WITH_UAN_MUST_PER_OF_BASIC" ||
                    rule[0] == "PF_RULE_WITH_UAN_MUST_PER_OF_BASIC_PLUS_DA" ||
                    rule[0] == "PF_RULE_WITH_UAN_MUST_PER_OF_BASIC_PLUS_GP_PLUS_DA" ||
                    rule[0] == "PF_RULE_WITH_UAN_MUST_PER_OF_BASIC_PLUS_DP_PLUS_DA" ||
                    rule[0] == "PER_OF_BASICS_PLUS_DA_PLUS_DP_PLUS_GRADDEPAY_PLUS_HRA_PLUS_TA_PLUS_CLA" ||
                    rule[0] == "PER_OF_BASICS_PLUS_DA_PLUS_DP_PLUS_GRADDEPAY_PLUS_HRA_PLUS_TA_PLUS_CLA_PLUS_SPECIALPAY_PLUS_SPECIALALLOWANCE"
                ) {
                    amount = amount + parseInt(basicpay);
                }

                if (
                    rule[0] == "PER_OF_BASIC_PLUS_GP" ||
                    rule[0] == "PER_OF_BASIC_PLUS_GP_PLUS_DA" ||
                    rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_GP_PLUS_DA" ||
                    rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_GP_PLUS_DA_PLUS_CLA_PLUS_TA_PLUS_OTHER ALLOWANCE" ||
                    rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_GP_PLUS_DA_PLUS_CLA_PLUS_TA_PLUS_OTHER ALLOWANCE_PLUS_ARREARS" ||
                    rule[0] == "PF_RULE_WITH_UAN_MUST_PER_OF_BASIC_PLUS_GP_PLUS_DA_PLUS_CLA_PLUS_TA_PLUS_OTHER_ALLOWANCE" ||
                    rule[0] == "PF_RULE_WITH_UAN_MUST_PER_OF_BASIC_PLUS_GP_PLUS_DA" ||
                    rule[0] == "TRAVEL_ALLOWANCE_RULE" ||
                    rule[0] == "PER_OF_BASICS_PLUS_DA_PLUS_DP_PLUS_GRADDEPAY_PLUS_HRA_PLUS_TA_PLUS_CLA" ||
                    rule[0] == "PER_OF_BASICS_PLUS_DA_PLUS_DP_PLUS_GRADDEPAY_PLUS_HRA_PLUS_TA_PLUS_CLA_PLUS_SPECIALPAY_PLUS_SPECIALALLOWANCE"
                ) {
                    amount = amount + parseInt(gradepay);
                }

                if (
                    rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_DA" ||
                    rule[0] == "PER_OF_BASIC_PLUS_DP_PLUS_DA" ||
                    rule[0] == "PER_OF_BASIC_PLUS_GP_PLUS_DA" ||
                    rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_GP_PLUS_DA" ||
                    rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_DP_PLUS_DA" ||
                    rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_GP_PLUS_DA_PLUS_CLA_PLUS_TA_PLUS_OTHER ALLOWANCE" ||
                    rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_GP_PLUS_DA_PLUS_CLA_PLUS_TA_PLUS_OTHER ALLOWANCE_PLUS_ARREARS" ||
                    rule[0] == "PF_RULE_WITH_UAN_MUST_PER_OF_BASIC_PLUS_GP_PLUS_DA_PLUS_CLA_PLUS_TA_PLUS_OTHER_ALLOWANCE" ||
                    rule[0] == "PF_RULE_WITH_UAN_MUST_PER_OF_BASIC_PLUS_GP_PLUS_DA" ||
                    rule[0] == "PF_RULE_WITH_UAN_MUST_PER_OF_BASIC_PLUS_DP_PLUS_DA" ||
                    rule[0] == "PF_RULE_WITH_UAN_MUST_PER_OF_BASIC_PLUS_DA" ||
                    rule[0] == "PER_OF_BASICS_PLUS_DA_PLUS_DP_PLUS_GRADDEPAY_PLUS_HRA_PLUS_TA_PLUS_CLA" ||
                    rule[0] == "PER_OF_BASICS_PLUS_DA_PLUS_DP_PLUS_GRADDEPAY_PLUS_HRA_PLUS_TA_PLUS_CLA_PLUS_SPECIALPAY_PLUS_SPECIALALLOWANCE"
                ) {
                    amount = amount + parseInt(da);
                }

                if (
                    rule[0] == "PER_OF_BASIC_PLUS_DP_PLUS_DA" ||
                    rule[0] == "PER_OF_BASIC_PLUS_DP" ||
                    rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_DP_PLUS_DA" ||
                    rule[0] == "PF_RULE_WITH_UAN_MUST_PER_OF_BASIC_PLUS_DP_PLUS_DA" ||
                    rule[0] == "PER_OF_BASICS_PLUS_DA_PLUS_DP_PLUS_GRADDEPAY_PLUS_HRA_PLUS_TA_PLUS_CLA" ||
                    rule[0] == "PER_OF_BASICS_PLUS_DA_PLUS_DP_PLUS_GRADDEPAY_PLUS_HRA_PLUS_TA_PLUS_CLA_PLUS_SPECIALPAY_PLUS_SPECIALALLOWANCE" 
                ) {
                    amount = amount + parseInt(dp);
                }
                if (rule[0] == "PER_OF_BASICS_PLUS_DA_PLUS_DP_PLUS_GRADDEPAY_PLUS_HRA_PLUS_TA_PLUS_CLA" ||
                    rule[0] == "PER_OF_BASICS_PLUS_DA_PLUS_DP_PLUS_GRADDEPAY_PLUS_HRA_PLUS_TA_PLUS_CLA_PLUS_SPECIALPAY_PLUS_SPECIALALLOWANCE"

                ) {
                    amount = amount + parseInt(hra);
                }

                if (
                    rule[0] == "PER_OF_BASICS_PLUS_DA_PLUS_DP_PLUS_GRADDEPAY_PLUS_HRA_PLUS_TA_PLUS_CLA" ||
                    rule[0] == "PER_OF_BASICS_PLUS_DA_PLUS_DP_PLUS_GRADDEPAY_PLUS_HRA_PLUS_TA_PLUS_CLA_PLUS_SPECIALPAY_PLUS_SPECIALALLOWANCE" ||
                    rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_GP_PLUS_DA_PLUS_CLA_PLUS_TA_PLUS_OTHER ALLOWANCE" ||
                    rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_GP_PLUS_DA_PLUS_CLA_PLUS_TA_PLUS_OTHER ALLOWANCE_PLUS_ARREARS" ||
                    rule[0] == "PF_RULE_WITH_UAN_MUST_PER_OF_BASIC_PLUS_GP_PLUS_DA_PLUS_CLA_PLUS_TA_PLUS_OTHER_ALLOWANCE"
                ) {
                    amount = amount + parseInt(ta);
                }

                if (
                    rule[0] == "PER_OF_BASICS_PLUS_DA_PLUS_DP_PLUS_GRADDEPAY_PLUS_HRA_PLUS_TA_PLUS_CLA" ||
                    rule[0] == "PER_OF_BASICS_PLUS_DA_PLUS_DP_PLUS_GRADDEPAY_PLUS_HRA_PLUS_TA_PLUS_CLA_PLUS_SPECIALPAY_PLUS_SPECIALALLOWANCE" ||
                    rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_GP_PLUS_DA_PLUS_CLA_PLUS_TA_PLUS_OTHER ALLOWANCE" ||
                    rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_GP_PLUS_DA_PLUS_CLA_PLUS_TA_PLUS_OTHER ALLOWANCE_PLUS_ARREARS" ||
                    rule[0] == "PF_RULE_WITH_UAN_MUST_PER_OF_BASIC_PLUS_GP_PLUS_DA_PLUS_CLA_PLUS_TA_PLUS_OTHER_ALLOWANCE"
                ) {
                    amount = amount + parseInt(cla);
                }

                if (
                    rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_GP_PLUS_DA_PLUS_CLA_PLUS_TA_PLUS_OTHER ALLOWANCE" ||
                    rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_GP_PLUS_DA_PLUS_CLA_PLUS_TA_PLUS_OTHER ALLOWANCE_PLUS_ARREARS" ||
                    rule[0] == "PF_RULE_WITH_UAN_MUST_PER_OF_BASIC_PLUS_GP_PLUS_DA_PLUS_CLA_PLUS_TA_PLUS_OTHER_ALLOWANCE") {
                    amount = amount + parseInt(otherallowance);
                }
                if(rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_GP_PLUS_DA_PLUS_CLA_PLUS_TA_PLUS_OTHER ALLOWANCE_PLUS_ARREARS"){
                    amount = amount + parseInt(arrears);
                }
                if(rule[0] == "PER_OF_BASICS_PLUS_DA_PLUS_DP_PLUS_GRADDEPAY_PLUS_HRA_PLUS_TA_PLUS_CLA_PLUS_SPECIALPAY_PLUS_SPECIALALLOWANCE"){
                    amount = amount + parseInt(sppa);
                }
                if(rule[0] == "PER_OF_BASICS_PLUS_DA_PLUS_DP_PLUS_GRADDEPAY_PLUS_HRA_PLUS_TA_PLUS_CLA_PLUS_SPECIALPAY_PLUS_SPECIALALLOWANCE"){
                    amount = amount + parseInt(spal);
                }

               if (rule[0] == "PROFESSIONAL_TAX_RULE" 
                    || rule[0] == "PER_OF_GROSS_EARNING"
                    || rule[0] == "PF_RULE_PER_OF_GROSS_EARNING" 
                    || rule[0] == "PF_RULE_WITH_UAN_MUST_PER_OF_GROSS_EARNING" 
                    || rule[0] == "ESIC_RULE" 
                    || rule[0] == "STAMP_RULE" ) {
                    amount = grosssalary;
                }

               // alert(amount)
                var islastmonth = "false";
                var gender = this.gender;
              //  alert(this.gender)
                var is_handicap = this.is_handicap;
               // alert(this.is_handicap)
                var is_uan = document.getElementById("is_uan").value;
               // alert(is_uan)
                var paycommision = this.emp_sal_master_details[0].paycommission;
                //alert(paycommision)

                var rulevalue;
               // alert(rule.length)
                if (rule.length > 1){
                    rulevalue = rule[1].split("_");
                   // alert(rulevalue)
                }
               // alert(rulevalue)
                var value = 0;
                if (rulevalue.length > 0) {
                    if (
                        rule[0] == "PER_OF_BASIC" ||
                        rule[0] == "PER_OF_BASIC_PLUS_GP" ||
                        rule[0] == "PER_OF_BASIC_PLUS_DP" ||
                        rule[0] == "PER_OF_GROSS_EARNING" ||
                        rule[0] == "PER_OF_BASIC_PLUS_GP_PLUS_DA" ||
                        rule[0] == "PER_OF_BASIC_PLUS_DP_PLUS_DA" ||
                        rule[0] == "PER_OF_BASICS_PLUS_DA_PLUS_DP_PLUS_GRADDEPAY_PLUS_HRA_PLUS_TA_PLUS_CLA" ||
                        rule[0] == "PER_OF_BASICS_PLUS_DA_PLUS_DP_PLUS_GRADDEPAY_PLUS_HRA_PLUS_TA_PLUS_CLA_PLUS_SPECIALPAY_PLUS_SPECIALALLOWANCE" 
                    ) {
                        value = Math.round((amount * parseFloat(rulevalue[0])) / 100);
                        // alert("final_value"+value)
                    }
                    if (
                        rule[0] == "PF_RULE_PER_OF_BASIC" ||
                        rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_DA" ||
                        rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_GP_PLUS_DA" ||
                        rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_DP_PLUS_DA" ||
                        rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_GP_PLUS_DA_PLUS_CLA_PLUS_TA_PLUS_OTHER ALLOWANCE" ||
                        rule[0] == "PF_RULE_PER_OF_BASIC_PLUS_GP_PLUS_DA_PLUS_CLA_PLUS_TA_PLUS_OTHER ALLOWANCE_PLUS_ARREARS" ||
                        rule[0] == "PF_RULE_PER_OF_GROSS_EARNING"
                    ) {
                        if (amount <= 0) value = 0;
                        else {
                            if (amount > parseFloat(rulevalue[1])) value = parseFloat(rulevalue[2]);
                            else {
                                value = Math.round((amount * parseFloat(rulevalue[0])) / 100);
                            }
                        }
                    } else if (
                        rule[0] == "PF_RULE_WITH_UAN_MUST_PER_OF_BASIC" ||
                        rule[0] == "PF_RULE_WITH_UAN_MUST_PER_OF_BASIC_PLUS_DA" ||
                        rule[0] == "PF_RULE_WITH_UAN_MUST_PER_OF_BASIC_PLUS_GP_PLUS_DA" ||
                        rule[0] == "PF_RULE_WITH_UAN_MUST_PER_OF_BASIC_PLUS_GP_PLUS_DA_PLUS_CLA_PLUS_TA_PLUS_OTHER_ALLOWANCE" ||
                        rule[0] == "PF_RULE_WITH_UAN_MUST_PER_OF_BASIC_PLUS_DP_PLUS_DA" ||
                        rule[0] == "PF_RULE_WITH_UAN_MUST_PER_OF_GROSS_EARNING"
                    ) {
                        if (is_uan == "true") {
                            if (amount <= 0) value = 0;
                            else {
                                if (amount > parseFloat(rulevalue[1])) value = parseFloat(rulevalue[2]);
                                else {
                                    value = Math.round((amount * parseFloat(rulevalue[0])) / 100);
                                }
                            }
                        }
                    } else if (rule[0] == "PROFESSIONAL_TAX_RULE") {
                        if (is_handicap == "true") {
                            value = parseFloat(rulevalue[7]);
                        } else if (amount > parseFloat(rulevalue[0])) {
                            if (islastmonth == "true") value = parseFloat(rulevalue[2]);
                            else value = parseFloat(rulevalue[1]);
                        } else if (amount <= parseFloat(rulevalue[0]) && amount > parseFloat(rulevalue[3])) {
                            if (gender == "Male") value = parseFloat(rulevalue[4]);
                            else value = parseFloat(rulevalue[5]);
                        } else if (amount <= parseFloat(rulevalue[3])) {
                            value = parseFloat(rulevalue[6]);
                        }
                    } else if (rule[0] == "TRAVEL_ALLOWANCE_RULE") {
                        if (paycommision == "6th") {
                            if (amount >= parseFloat(rulevalue[0])) {
                                if (is_handicap == "true") value = parseFloat(rulevalue[2]);
                                else value = parseFloat(rulevalue[5]);
                            } else if (amount < parseFloat(rulevalue[0]) && amount >= parseFloat(rulevalue[1])) {
                                if (is_handicap == "true") value = parseFloat(rulevalue[3]);
                                else value = parseFloat(rulevalue[6]);
                            } else if (amount <= parseFloat(rulevalue[1])) {
                                if (is_handicap == "true") value = parseFloat(rulevalue[4]);
                                else value = parseFloat(rulevalue[7]);
                            }
                        } else if (paycommision == "5th") {
                            if (is_handicap == "true") value = parseFloat(rulevalue[8]);
                            else value = parseFloat(rulevalue[9]);
                        }
                    }
                    else if(rule[0] == "ESIC_RULE"){
                        //amount = amount + parseInt(esic);
                        if (amount <= parseFloat(rulevalue[1])) {
                           // value = parseFloat(rulevalue[0]);
                           value = Math.round((amount * parseFloat(rulevalue[0])) / 100);
                        }
                    }
                    else if(rule[0] == "STAMP_RULE"){
                        //amount = amount + parseInt(esic);
                        if (amount <= parseFloat(rulevalue[1])) {
                           value = parseFloat(rulevalue[0]);
                        }else{
                            value = parseFloat(rulevalue[2]);
                        }
                    }
                } 
                //alert("return value"+value);
                return parseFloat("" + value);
            },
            updateEmpSalaryMaster(){
                this.create_loader = true
                 const data = {
                    fromdate: this.from_date_edit,
                    todate: this.end_date_edit,
                    emp_sal_master_details :this.emp_sal_master_details,
                    grossearn: this.grossearn,
                    grossdeduct: this.grossdeduct,
                    netsal: this.grossdeduct,
                };
                 axios
                    .post("/Payroll/updateEmpSalaryMaster", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                           this.showSnackbar("#4caf50", "Salary Master Updated Successfully...");
                           this.create_loader = false
                             this.$emit('changedialog',false);
                        } else {
                             this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.create_loader = false
                         this.$emit('changedialog',false);
                    })
                    .finally(() => {
                        this.onload()
                         this.emp_salary_component_list = []
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            addrule_edit(comp_rule) {
                for (var i = 0; i < this.emp_sal_master_details[0].component_rule.length; i++) {
                   // alert(comp_rule.salarycomponent_id)
                    //alert(this.emp_sal_master_details[0].component_rule.s_id)
                    
                    if (comp_rule.salarycomponent_id == this.emp_sal_master_details[0].component_rule[i].s_id) {
                        //alert("in if")
                        this.emp_sal_master_details[0].component_rule.rule_value = comp_rule.value_for_rule;
                        var compvalue = document.getElementsByClassName("compvalue");
                        var compname = document.getElementsByClassName("compname");
                        var comprule = document.getElementsByClassName("comprule");
                        var comptype = document.getElementsByClassName("comptype");
                        var iscalculationnotapply = document.getElementsByClassName("iscalculationnotapplyall");
                        for (var i = 0; i < compname.length; i++) {
                            if (compname[i].value == comp_rule.s_name) {
                                comprule[i].value = comp_rule.value_for_rule;
                                comptype[i].value = comp_rule.salarycomponenttype;
                                iscalculationnotapply[i].value = comp_rule.is_not_for_calculation;
                                compvalue[i].value = comp_rule.s_value;
                                comprule_id[i].value = comp_rule.rule_id;
                            }
                        }
                        this.calculateRuleWise();
                        this.recalculate();
                    }
                    else {
                       // alert("in else")
                        this.emp_sal_master_details[0].component_rule.rule_value = this.emp_sal_master_details[0].component_rule.rule_value;
                    }
                }
                this.dialog_edit_rule = false;
            },
            addRule(sid) {
                const data = {
                    sid: sid,
                };
                axios
                    .post("/Payroll/addComponentRule", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.component_rule = res.data.component_rule;
                            this.dialog_edit_rule = true;
                        } else {
                             this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    });
            },
            removeRule(s){
                s.s_value = 0,
                s.rule_value = "",
                s.rule_id = ""
                this.recalculate();
            },
            onload() {
               const data = {
                    emp_sal_id: this.emp_sal_id,
                };
                axios
                    .post("/Payroll/getEmpSalInfoForEdit", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.emp_sal_master_details = res.data.emp_sal_master_details;
                            this.gender = res.data.gender;
                            this.pfno = res.data.pfno;
                            this.uan_no = res.data.uan_no;
                            this.is_handicap = res.data.is_handicap;
                            this.aadhar_no = res.data.aadhar_no;
                            this.from_date_edit = res.data.emp_sal_master_details[0].fromdate;
                            this.end_date_edit = res.data.emp_sal_master_details[0].todate;
                        }
                        else{
                             this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    });
            },
        },
    };
</script>
<style scoped>
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .delete-avatar:hover {
        background-color: #b0bec5;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .mytable /deep/ thead th {
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>
